import {
    createActionSet,
    createCrudActionSets,
    createDeletePromptActionSet,
    createNoPropsAction,
    createRequestAction,
} from "@app/root-store/actions/action-creators";

import { Address } from "@app/address/model/address";
import { Entity } from "@app/entity/model/entity";
import { EntityWithAncestors } from "@app/entity/services/entity-db.service";
import { ActionPayloadGeneric } from "@app/root-store/actions";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { User } from "@app/user/model/user";
import { TypedAction } from "@ngrx/store/src/models";

const actionCategory = "Entity";

export type ActionPayload = { entity: Entity } & ActionPayloadGeneric;

export interface LoadActionPayload {
    parentId: number;
}
export interface BulkActionResult {
    entities: ClareDbCollection<Entity>;
}
export interface ActionResult {
    entity: Entity;
}

export type EntityAddressActionPayload = {
    entity: Entity;
    address: Address;
    addressType?: "shipping" | "billing";
} & ActionPayloadGeneric;

export type EntityUserActionPayload = {
    entity: Entity;
    user: User;
    userType?: "shipping" | "billing";
} & ActionPayloadGeneric;

export type EntityAction = ActionPayload & TypedAction<string>;

/**
 * Create the CRUD set of actions associated with the action category.
 * Must send in appropriate payload types for a single and load and result types for single and bulk.
 * A request, success and failure action are created for each CRUD operation.
 * Each action set should be deconstructed into consts from the result.
 */
export const {
    loadSingle: loadSingleSet,
    create: createSet,
    update: updateSet,
    delete: deleteSet,
} = createCrudActionSets<ActionPayload, LoadActionPayload, ActionResult, BulkActionResult>(actionCategory);

export const loadSet = createActionSet<LoadActionPayload & ActionPayloadGeneric, { entities: ClareDbCollection<EntityWithAncestors> }>(
    actionCategory,
    "Load"
);

// export const createSet = createActionSet<{ entity: CreateEntityPayload } & ActionPayloadGeneric, { entity: Entity }>(
//     actionCategory,
//     "Create"
// );
export const clearEntityState = createNoPropsAction(actionCategory, "Clear Entity State");

/**
 * An action set to prompt a user when deleting an item
 */
export const { confirm: deleteConfirmation, dismiss: deleteConfirmationDismiss } =
    createDeletePromptActionSet<ActionPayload>(actionCategory);

export const deleteConfirmationSet = { ...deleteSet, deleteConfirmation, deleteConfirmationDismiss };

const updateEntityUser = createRequestAction<EntityUserActionPayload>(actionCategory, "Update User");

export const removeEntityAddressSet = createActionSet<EntityAddressActionPayload>(actionCategory, "Remove Address");
export const updateEntityAddress = createRequestAction<EntityAddressActionPayload>(actionCategory, "Update Address");
export const updateEntityUserSet = { request: updateEntityUser, success: updateSet.request, failure: updateSet.failure };
